import Cookies from 'js-cookie';

class CartCounter extends HTMLElement {
  #value = 0;

  constructor() {
    super();

    globalThis.addEventListener('cartchange', this.#update); // NOTE: use this event to provide the content of the cart: event.detail.items
    setInterval(this.#update, 1500); // auto update
    this.#render();
    this.#update();
  }

  #update = () => {
    const value = this.#getCartProductCount();
    if (this.#value !== value) {
      this.#value = value;
      this.#render();
    }
  };

  /**
   * Propagates changes to the dom.
   *
   * @returns {void}
   */
  #render() {
    this.textContent = this.#value < 100 ? this.#value : '99+';
    this.toggleAttribute('hidden', this.#value === 0);
  }

  /**
   * Get the number of products in the cart.
   *
   * @returns {number} The number of products in the cart.
   */
  #getCartProductCount() {
    const countString = Cookies.get('NBART') || '0';
    const count = Number.parseInt(countString, 10);
    return Number.isNaN(count) ? 0 : count;
  }
}

customElements.get('f-cart-counter') || customElements.define('f-cart-counter', CartCounter);
